var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"play-arrow-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"21","height":"26","viewBox":"0 0 21 26","fill":"none"}},[_c('path',{attrs:{"d":"M0.666504 25.8334V0.166687L20.8332 13L0.666504 25.8334Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }